import classNames from 'classnames'
import * as React from 'react'

import {getComparisonSlug} from '@/../lib/storyblok/helpers'
import {isEmptyRichtext, makeEditable} from '@/common/utils'
import Button from '@/components/Button'
import Content from '@/components/Content'
import {Grid} from '@/components/Grid'
import Heading from '@/components/Heading'
import Kicker from '@/components/Kicker'

const ComparisonDropdown = ({
  backgroundColors,
  id,
  headingTag,
  kicker,
  heading,
  labelA,
  labelB,
  buttonLabel,
  content,
  _editable,
  story,
}) => {
  const HeadingTag = headingTag || 'p'

  const solutions =
    story.comparison_database && Array.isArray(story.comparison_database.solutions)
      ? story.comparison_database.solutions
      : []

  const [selected, setSelected] = React.useState(solutions.length > 0 ? [solutions[0]._uid] : [])
  const [hasError, setHasError] = React.useState()

  function handleChange(event, index) {
    setHasError(false)

    if (index === 0) {
      setSelected((p) => [event.target.value, p[1]])
    } else if (index === 1) {
      setSelected((p) => [p[0], event.target.value])
    }
  }
  function handleNavigation() {
    const first = solutions.find(({_uid}) => _uid === selected[0])
    const second = solutions.find(({_uid}) => _uid === selected[1])

    if (first && second) {
      window.location.href = `/${getComparisonSlug(first.name, second.name)}/`
    } else {
      setHasError(true)
    }
  }

  return (
    <section
      id={id ? id : undefined}
      {...makeEditable(_editable)}
      className={classNames('overflow-hidden py-12', backgroundColors.current)}
    >
      <Grid className='gap-y-8 text-center'>
        <HeadingTag className='relative col-span-full mx-auto mb-8 w-fit md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3'>
          <Kicker kicker={kicker} />
          <Heading heading={heading} className='block' />
        </HeadingTag>

        {!isEmptyRichtext(content) && (
          <div className='relative col-span-full mx-auto md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3'>
            <Content content={content} size='l-medium' />
          </div>
        )}

        <div className='col-span-full grid grid-cols-2 flex-wrap justify-center gap-4 lg:col-span-8 lg:col-start-3 lg:grid-cols-3 lg:items-end'>
          {[0, 1].map((index) => {
            const label = index === 0 ? labelA : labelB
            const placeholder = index === 1 ? '…' : undefined
            const exclude = index === 0 ? selected[1] : selected[0]
            return (
              <label key={index} className='body-m-medium relative text-left text-purple-900'>
                {label}
                <select
                  onChange={(e) => handleChange(e, index)}
                  className='h-14 w-full appearance-none overflow-hidden overflow-ellipsis rounded-2xl border border-purple-300 bg-white px-2 pl-4 pr-11 focus:outline-violet-600'
                >
                  {!!placeholder && <option>{placeholder}</option>}
                  {solutions
                    .filter(({_uid}) => _uid !== exclude)
                    .map(({_uid, name}) => (
                      <option key={_uid} value={_uid}>
                        {name}
                      </option>
                    ))}
                </select>
                <ChevronIcon className='pointer-events-none absolute bottom-2 right-2' />
              </label>
            )
          })}

          <div className='col-span-full lg:col-span-1'>
            <Button
              onClick={handleNavigation}
              label={buttonLabel || 'Voir le comparatif'}
              as='button'
              hasIcon={false}
              theme='secondary'
              className='mx-auto whitespace-nowrap'
            />
          </div>
        </div>

        {!!hasError && (
          <p className='col-span-full text-red-800'>
            Vous devez sélectionner deux solutions à comparer.
          </p>
        )}
      </Grid>
    </section>
  )
}

const ChevronIcon = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      fill='none'
      viewBox='0 0 40 40'
      {...props}
    >
      <path
        className='stroke-purple-900'
        strokeLinecap='round'
        d='M26.67 16.67 20 23.33l-6.67-6.66'
      />
      <path
        stroke='#000'
        strokeLinecap='round'
        strokeOpacity='.2'
        d='M26.67 16.67 20 23.33l-6.67-6.66'
      />
    </svg>
  )
}

export default ComparisonDropdown
